import { ReactNode } from "react";
import { FormItem, TextArea, TextAreaProps } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useField } from "formik";

type TextAreaFieldProps = {
  name: string;
  label?: string;
  info?: ReactNode;
};

const TextAreaField = (props: TextAreaFieldProps & TextAreaProps) => {
  const { t } = useTranslation();
  const { name, label, info, ...textAreaProps } = props;
  const [field, meta] = useField(name!);

  const hasFeedback = !!(meta.touched && meta.error);
  const help = meta.touched && meta.error && t(meta.error);
  const validateStatus = meta.touched && meta.error ? "error" : undefined;

  return (
    <FormItem
      help={hasFeedback ? help : undefined}
      validateStatus={validateStatus}
      label={label}
      info={info}
    >
      <TextArea {...textAreaProps} {...field} />
    </FormItem>
  );
};

export { TextAreaField };
